module.exports = __webpack_public_path__ + "static/img/KZ.1c10d34c.png";